//TheBlockLogo.tsx

import React from 'react';
import { ReactComponent as TheBlockLogoSVG } from '../../icons/TheBlockLogo.svg';

export default function TheBlockLogo() {
  return <TheBlockLogoSVG />;
}
